import { Component } from '@angular/core';

/**
 * Container de formulário: área principal (conteúdo projetado) + rodapé para botões.
 *
 * **Quando usar:** telas de inclusão/alteração/consulta que seguem o padrão visual
 * do projeto. Projete campos no corpo e ações no rodapé com `form-box-footer`
 * (diretiva de atributo no elemento filho).
 *
 * **Responsabilidade:** apenas layout e scroll; validação, `Router` e chamadas HTTP
 * ficam no componente da página.
 */
@Component({
  selector: 'app-form-box',
  templateUrl: './form-box.component.html',
  styleUrls: ['./form-box.component.scss'],
})
export class FormBoxComponent {}
